module.exports = __webpack_public_path__ + "media/Outdoor Tai Chi.5bf21bf0.mp4";